/* eslint-disable react/jsx-no-undef */
import { Field as FinalFormField } from 'react-final-form';
import { composeValidators } from '@rainbow-modules/forms';
import ChevronDown from 'components/icons/chevronDown';
import PhoneInput from 'components/PhoneInput';
import StyledTextarea from 'components/Textarea';
import { validateNotEmpty, validatePhoneNumber } from 'data/validators';
import { FieldsSection, StyledLookup } from './styled';

const Field = (props: any) => <FinalFormField parse={(value) => value} {...props} />;

const Fields = ({ phoneTypes = [] }: { phoneTypes?: string[] }) => (
    <FieldsSection>
        <Field
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component={PhoneInput}
            name="phoneNumber"
            label="Phone Number"
            labelAlignment="left"
            placeholder=""
            borderRadius="semi-rounded"
            validate={composeValidators(
                validateNotEmpty('This field is required'),
                validatePhoneNumber,
            )}
            required
        />
        <Field
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component={StyledLookup}
            name="phoneType"
            label="Phone Type"
            labelAlignment="left"
            borderRadius="semi-square"
            icon={<ChevronDown />}
            required
            validate={validateNotEmpty('This field is required')}
            options={phoneTypes.map((type) => ({
                label: type,
                value: type,
            }))}
        />
        <Field
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component={StyledTextarea}
            name="note"
            label="Note"
            labelAlignment="left"
            borderRadius="semi-rounded"
            placeholder="Add some notes about this phone number"
        />
    </FieldsSection>
);

export default Fields;
